import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Fire, Flag } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { localDate, readStore, stats } from "@/lib/mini";

// Lobby card for today's mini puzzle (pages/Mini.jsx), from this device's
// results (merged with the account's once /mini has been opened signed in).
export default function MiniCard({ className = "" }) {
  const [n, setN] = useState(null);
  const [par, setPar] = useState(null);
  useEffect(() => {
    api.get("/mini/day", { params: { date: localDate() } })
      .then((r) => { setN(r.data.n); setPar(r.data.puzzle?.par); })
      .catch(() => {});
  }, []);
  if (!n) return null;
  const { results } = readStore();
  const r = results[n] || {};
  const { streak } = stats(results, n);
  const status = r.won
    ? `Flag captured in ${r.moves} move${r.moves === 1 ? "" : "s"} (par ${r.par})`
    : r.finished
    ? "Blue held on today. New one at midnight."
    : r.history?.length
    ? `On move ${r.history.length + 1}. Blue is waiting.`
    : `Beat Blue to the flag · par ${par} moves`;
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center gap-4 p-5 md:px-8 rounded-2xl border border-border bg-surface ${className}`}
      data-testid="mini-card"
    >
      <div className="flex items-center gap-4 min-w-0">
        <div className="w-12 h-12 rounded-xl bg-opp/15 text-opp flex items-center justify-center flex-none">
          <Flag size={26} weight="duotone" />
        </div>
        <div className="min-w-0">
          <div className="font-display text-xl font-bold tracking-tight">Mini #{n}</div>
          <div className="text-sm text-muted-foreground">
            {status}
            {streak > 0 && (
              <span className="ml-2 inline-flex items-center gap-0.5 text-orange-400 font-semibold">
                <Fire size={14} weight="fill" /> {streak}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="sm:ml-auto flex gap-2">
        <Button asChild className="rounded-full bg-opp hover:bg-opp-hover text-white" data-testid="mini-card-play">
          <Link to="/mini">
            {r.finished ? "See result" : "Play"} <ArrowRight size={15} weight="bold" className="ml-1" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
